// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { Resources } from "../../Commons/properties/Resources.js";
import { HistoryType } from "../../Utils/History/HistoryType.ts";
import { TerceraChartCashItemSeriesDataType } from "../Series/TerceraChartCashItemSeriesEnums.js";
import { PlateBase } from "./PlateBase.js";
import { PriceFormatter } from "../../Utils/Instruments/PriceFormatter.js";

export let PlateOverlay = function (terceraChartOverlay)
{
    PlateBase.call(this, [terceraChartOverlay]);

    this.ValueBrush;
    this.terceraChartOverlay = terceraChartOverlay;
    this.isOverlay = true;
};
PlateOverlay.prototype = Object.create(PlateBase.prototype);

PlateOverlay.prototype.GetHover = function ()
{
    return this.terceraChartOverlay.Selected;
};
PlateOverlay.prototype.SetHover = function (value)
{
    this.terceraChartOverlay.Selected = value;
};

PlateOverlay.prototype.GetSelected = function ()
{
    return this.terceraChartOverlay.chart.ActiveOverlayGet() == this.terceraChartOverlay;
};
PlateOverlay.prototype.SetSelected = function (value)
{
    this.terceraChartOverlay.chart.FocusedOverlay = this.terceraChartOverlay;
    this.terceraChartOverlay.chart.ActiveOverlaySet(this.terceraChartOverlay);
};

PlateOverlay.prototype.GetVisible = function ()
{
    return this.terceraChartOverlay.mainPriceRenderer.Visible;
};

PlateOverlay.prototype.getTextName = function ()
{
    if (this.terceraChartOverlay.ActiveInstrument != null)
        return Resources.getResource("chart.menu.PlateOverlay.Overlay") + ": " + this.terceraChartOverlay.ActiveInstrument.DisplayName();

    return "Empty symbol";
}
PlateOverlay.prototype.getTextValue = function (lastMouseHoverBarIndex, lineNumber, seriesSettings = null)
{
    if (this.terceraChartOverlay.mainPriceRenderer.Series == null)
        return "";

    //http://tp.pfsoft.net/entity/41138
    if (lastMouseHoverBarIndex < 0)
        return "---";

    if (!this.terceraChartOverlay.mainPriceRenderer.Series.CashItem.FNonEmptyCashArray[lastMouseHoverBarIndex])
        return "---";

    var value = this.terceraChartOverlay.mainPriceRenderer.Series.CashItem.FNonEmptyCashArray[lastMouseHoverBarIndex].Close;

    if (Math.abs(value) == Number.MAX_VALUE || isNaN(value))
        value = 0;

    if (this.terceraChartOverlay.ActiveInstrument != null)
    {
        var dataType = seriesSettings != null ? seriesSettings.DataType : TerceraChartCashItemSeriesDataType.Absolute;
        switch (dataType)
        {
            case TerceraChartCashItemSeriesDataType.Relative:
                return seriesSettings.relativeDataConverter.Calculate(value) + "%";
        }

        return this.terceraChartOverlay.ActiveInstrument.formatPrice(value);
    }
    else
        return PriceFormatter.formatPrice(value, 5);
}

PlateOverlay.prototype.getBrush = function (lineNumber)
{
    if (this.terceraChartOverlay.HistoryType === HistoryType.ASK)
        return this.terceraChartOverlay.AskOverlayBrush;
    else if (this.terceraChartOverlay.HistoryType === HistoryType.LAST)
        return this.terceraChartOverlay.LastOverlayBrush;
    else
        return this.terceraChartOverlay.BidOverlayBrush;
}
PlateOverlay.prototype.getLinesCount = function ()
{
    return 1; // close only
}

PlateOverlay.prototype.Dispose = function ()
{
    this.terceraChartOverlay = null;
}

PlateOverlay.prototype.getTypeName = function ()
{
    return this.getPropertiesText() + " " + this.getTextName();
};
PlateOverlay.prototype.getCloseTT = function ()
{
    return this.getCloseText() + " " + this.getTextName();
};
PlateOverlay.prototype.getVisibilityTT = function ()
{
    return "Show/Hide overlay lines";
};

PlateOverlay.prototype.getPropertiesText = function ()
{
    return Resources.getResource('chart.menu.PlateOverlaySettings');
};
PlateOverlay.prototype.getCloseText = function ()
{
    return Resources.getResource('chart.menu.PlateOverlayRemove');
};
PlateOverlay.prototype.getVisibilityText = function ()
{
    return Resources.getResource('chart.menu.PlateOverlayVisible');
};

export { PlateBase };
